import { useFormContext } from "react-hook-form";
import { AdditionalInfoSummary as SharedAdditionalInfoSummary } from "../../../../../shared/additional-info/AdditionalInfoSummary";
import { type AccountFormValues, fp } from "../../schema";

export const AdditionalInfoSummary = () => {
	const { getValues } = useFormContext<AccountFormValues>();
	const additionalInfo = getValues().account.additionalInfo;

	return (
		<SharedAdditionalInfoSummary
			comment={additionalInfo.comment}
			attachments={additionalInfo.attachments}
			commentFieldPath={fp("account.additionalInfo.comment")}
			attachmentsFieldPath={fp("account.additionalInfo.attachments")}
		/>
	);
};
